export type CultureType = {
  title: string;
  description: string;
  image: string;
  reverse: boolean;
};

export const CULTURES: CultureType[] = [
  {
    title: "cultures.0.title",
    description: "cultures.0.description",
    image: "parties",
    reverse: false,

  },
  {
    title: "cultures.1.title",
    description: "cultures.1.description",
    image: "ideas",
    reverse: true,

  },
  {
    title: "cultures.2.title",
    description: "cultures.2.description",
    image: "team",
    reverse: false,

  },
  {
    title: "cultures.3.title",
    description: "cultures.3.description",
    image: "talents",
    reverse: true,

  },
  {
    title: "cultures.4.title",
    description: "cultures.4.description",
    image: "sport",
    reverse: false,

  },
];